import { PageHeader, Section } from "@/components/Section";

export default function Accessibility() {
  return (
    <>
      <PageHeader
        overline="Accessibility"
        title="Accessibility statement."
        lede="Public-sector buyers procure against accessibility requirements. We treat that as a feature, not paperwork."
        testid="accessibility-page-header"
      />
      <Section className="!pt-16">
        <div className="max-w-prose prose-continuum">
          <h2>Commitment</h2>
          <p>
            Continuum is committed to meeting <strong>WCAG 2.1 AA</strong> on both this
            marketing site and the platform itself. We test against that standard as part of
            our release process and document gaps in the open.
          </p>

          <h2>What we currently do</h2>
          <ul>
            <li>Semantic HTML structure with proper heading hierarchy on every page.</li>
            <li>All interactive elements keyboard-operable. Visible focus outlines preserved.</li>
            <li>Text contrast verified against AA thresholds for body and interactive text.</li>
            <li>Form fields paired with explicit labels. Error and success states announced.</li>
            <li>No motion-only signalling. Animation respects <span className="font-mono">prefers-reduced-motion</span>.</li>
            <li>Decorative SVGs marked <span className="font-mono">aria-hidden</span>. Meaningful ones carry titles or aria-labels.</li>
          </ul>

          <h2>Known limitations</h2>
          <ul>
            <li>Map interactions on the platform currently require a pointing device; we are working on a non-mouse alternative.</li>
            <li>Some methodology artefacts (PDF exports of statutory reports) are produced from a generator that we are still tagging for full PDF/UA compliance.</li>
          </ul>

          <h2>Tell us</h2>
          <p>
            If something on the site fails for you, please email{" "}
            <a href="mailto:hello@getcontinuum.com" className="text-[#FF8A00] font-bold underline underline-offset-4">hello@getcontinuum.com</a>{" "}
            with the page URL and the assistive technology you're using. We respond within two
            business days and publish fixes in the next release.
          </p>
        </div>
      </Section>
    </>
  );
}
